import React from 'react';


export const Relatoriodesempenho=[
    {
        title:"Cliente com consumo excessivo",
        link:"consumo_excessivo"

    },
    {
        title:"Cliente com consumo Inadequado",
        link:"consumo_Inadequado"

    },
    {
        title:"Cliente Sem Consumo ",
        link:"sem_consumo"

    },
    {
        title:"Registo de Clientes",
        link:"Registo_Clientes"

    },
    {
        title:"Registo de Cancelamento de Cliente",
        link:"Calcelamento"

    },
    {
        title:"Registo de Vendas",
        link:"vendas_registo"

    },
    {
        title:"Registo de Compra do Cliente",
        link:"comprasdf"

    },
    {
        title:"Total de Vendas",
        link:"total_vendas"

    },
    


]